import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import focus from '@mailobj-browser/front/js/events/types/focus.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { completion } from '../list/list.js'

const onFocus = object(listener, {
  type: focus,
  once,
  passive,
  task: async (
    input,
    event
  ) => {
    await completion(input, event)
    onFocus.listen(input)
  }
})

export default async (
  input
) => {
  const { ownerDocument } = input
  
  onFocus.listen(input)
  
  if (ownerDocument.activeElement === input) {
    await onFocus.task(input)
  }
}
